/**
 * CartPanel.js — Potter's Vineyard order summary (message kind "cart").
 *
 * Extends the base CartPanel (Commerce7 sku-keyed line controls, live
 * re-render on ws-cart-count, in-place +/− via fromCart) and only swaps in the
 * old prod copy — live pottersvineyard.winespeak.ai main.js showCartsProducts:
 *   - line meta "{volumeInML}ml | {price} per bottle"
 *   - no Bottle Deposit Total row (Subtotal → Estimated total only)
 *   - "Proceed to Checkout" (capital C) + "Continue Shopping"
 *
 * Layout and colors (no outer card, bordered line box, dividers, outlined
 * buttons) live in ../styles.css under :host(.ws-tenant-pottersvineyard).
 */
import CartPanel from "../../../components/base/CartPanel.js";

export default class PVCartPanel extends CartPanel {
  get showBottleDepositTotal() {
    return false;
  }

  _row(item) {
    const row = super._row(item);
    const meta = row.querySelector(".ws-cart-item-meta");
    if (meta && item.volumeInML) {
      meta.textContent = `${item.volumeInML}ml | ${item.price} per bottle`;
    }
    return row;
  }

  _renderActions() {
    const footer = super._renderActions();
    // Base order: [Proceed to checkout, Continue Shopping].
    const checkout = footer.querySelector(".ws-cart-action-btn");
    if (checkout) checkout.textContent = "Proceed to Checkout";
    return footer;
  }
}
